'use client';

import { tw } from '../../utils';

interface DetailTitleProps {
  text: string;
}

export const DetailTitle: React.FC<DetailTitleProps> = ({
  text,
}: DetailTitleProps) => {
  return (
    <h1 className={tw('w-full text-[32px] font-medium capitalize leading-9')}>
      {text}
    </h1>
  );
};
